import {useParams} from 'react-router-dom';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import NotificationRuleForm from '../Shared/NotificationRuleForm';
import {NotificationRuleDocumentTitle} from '../notificationRuleHelpers';

export const ViewNotificationRulePage = () => {
  useSetDocumentTitle(NotificationRuleDocumentTitle);
  const {id} = useParams();
  return (
    <ContentWrapper>
      {id !== undefined && <NotificationRuleForm id={Number(id)} mode="view" />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.NotificationRuleView(':id'),
  element: <ViewNotificationRulePage />,
  module: ModuleEnum.NotificationRules,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewNotificationRulePage;
